import type { OrgUser } from '../types';

/**
 * The signed-in person's directory id across every seed. Read it through `CurrentUserService.id()`
 * in services and components; only seeds import the constant.
 */
export const CURRENT_USER_ID = 'usr-aiden';

export const ORG_USERS: ReadonlyArray<OrgUser> = [
  { id: 'usr-aiden', name: 'Aiden Hemmings', initials: 'AH' },
  { id: 'usr-sarah', name: 'Sarah Pillay', initials: 'SP' },
  { id: 'usr-james', name: 'James Okoro', initials: 'JO' },
  { id: 'usr-mia', name: 'Mia Chen', initials: 'MC' },
];
